// extracted by mini-css-extract-plugin
export var container = "_r0-0";
export var dotAnimation = "_r0-2";
export var dotsLoading = "_r0-1";